import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import { superAdmin_Data } from "../../Data/data";
import "./Dashboard.css";
import { useNavigate } from "react-router-dom";
import DashboardCard from "./DashboardCard/DashboardCard";
import { useDispatch, useSelector } from "react-redux";
import functions from "../../utils/Api";
import { setUserTypeData } from "../../Redux/persistApiDataSlice";

const Dashboard = ({ loginDetails }) => {
  let navigate = useNavigate();
  const dispatcher = useDispatch();
  const { userPermissions } = useSelector((state) => state.report);
  const [permissionList, setPermissionList] = useState([]);

  useEffect(() => {
    let permissionData =
      userPermissions.length === 0 ? loginDetails.permission : userPermissions;
    setPermissionList(permissionData);
  }, [loginDetails, userPermissions]);

  useEffect(() => {
    try {
      functions.get("/role").then((res) => {
        if (res) {
          dispatcher(setUserTypeData(res?.data)); //need to persisted the data
        }
      });
    } catch (error) {
      console.log(error);
    }
  }, [dispatcher]);

  const handleRedirect = (route) => {
    navigate(route);
  };

  return (
    <Box>
      <Grid container spacing={2} className="dashboard-gridContainer">
        {permissionList &&
          permissionList.map((item, i) => {
            return (
              <>
                {item.permissionName === "accessToCms" ? (
                  <>
                    <DashboardCard
                      icon={
                        <PeopleOutlineIcon
                          sx={{ width: "40px", height: "40px" }}
                        />
                      }
                      label="Manage Users"
                      path="/cms/users-list"
                      handleRedirect={handleRedirect}
                    />
                  </>
                ) : item.permissionName === "accessToReports" ? (
                  <>
                    <DashboardCard
                      icon={
                        <LeaderboardOutlinedIcon
                          sx={{ width: "40px", height: "40px" }}
                        />
                      }
                      label="Reports"
                      path="/cms/reports"
                      handleRedirect={handleRedirect}
                    />
                  </>
                ) : item.permissionName === "accessToInvoice" ? (
                  <>
                    <DashboardCard
                      icon={
                        <ReceiptOutlinedIcon
                          sx={{ width: "40px", height: "40px" }}
                        />
                      }
                      label="Invoice"
                      path="/cms/invoice"
                      handleRedirect={handleRedirect}
                    />
                  </>
                ) : (
                  ""
                )}
              </>
            );
          })}
        {/* <DashboardCard /> */}
      </Grid>
    </Box>
    // <Grid container spacing={2} className="AdminDashboard">
    //   {superAdmin_Data.map((item, i) => {
    //     return (
    //       <React.Fragment key={i}>
    //         <Grid item lg={2}>
    //           <Card
    //             className="AdminDashboard-cardMain"
    //             onClick={() => handleRedirect(item.route)}
    //           >
    //             <CardContent>
    //               <Box className="AdminDashboard-cardMain-icon">
    //                 {item.icon}
    //               </Box>
    //               <Box className="AdminDashboard-cardMain-actions">
    //                 <Typography className="AdminDashboard-cardMain-actions-label">
    //                   {item.label}
    //                 </Typography>
    //                 <ChevronRightOutlinedIcon />
    //               </Box>
    //             </CardContent>
    //           </Card>
    //         </Grid>
    //       </React.Fragment>
    //     );
    //   })}
    // </Grid>
  );
};

export default Dashboard;
